// Registre des actions : le même objet que window.actions, que les onclick inline et data-action appellent.
export const actions = (window.actions = window.actions || {});
export function enregistrer(nom, fn) { actions[nom] = fn; return fn; }
export function executer(nom, args, ev, el) {
    var fn = actions[nom];
    if (typeof fn !== 'function') { if (window.signalerErreur) window.signalerErreur(new Error('Action inconnue : ' + nom), 'action'); return; }
    return fn.apply(null, (args || []).concat(el ? [el, ev] : []));
}
